import React, { useRef } from 'react'
import { PushGADataLayer, pureKeys } from "../../utils/helpers"

export default function FooterCols(props) {
  const { group, groupInd, handleToggle, active } = props
  
  const isActive = active === groupInd ? "active" : ""
  const contentEl = useRef(null)

  return (
    <aside className={`border-b border-white/20 lg:border-0 -mx-4 lg:mx-0 p-4 lg:p-0 group ${isActive}`}>
      <div className="flex justify-between" tabIndex={0} aria-label={group.heading} onClick={() => handleToggle(groupInd)}>
        {group.heading && <h4 className="lg:mb-5">{group.heading}</h4>}
        <img src="/images/icons/chevron-down.svg" alt="chevron-down" loading="lazy" className="lg:hidden mt-1 group-[.active]:rotate-180 transition-transform" width={24} height={24}/>
      </div>
      <div ref={contentEl} className={`grid gap-y-3 group-[.active]:mt-4 group-[.active]:lg:mt-0 text-sm overflow-hidden transition-all duration-500 h-[var(--fooAccPanel)] lg:h-auto`} style={
          active === groupInd
            ? { '--fooAccPanel': contentEl?.current?.scrollHeight + 'px' }
            : { '--fooAccPanel': "0px" }
        }>
        {group.links?.map((item, itemInd) => (
          <a href={item.href} target={item.target} key={pureKeys(item.title) + itemInd} className="hover:underline hover:underline-offset-2" onClick={() => PushGADataLayer('Navigations','Footer Navigation',item.title)}>{item.title}</a>
        ))}
      </div>
    </aside>
  )
}
